import { SearchableModelHelper } from '~/lib/forms/select';
import * as locationApis from '../apis/locations';
import * as organizationApis from '../apis/organizations';


// Organization search helper
export const createOrganizationHelper = (refreshFn, getById?, getList?, orgType?: string) => {
  return new SearchableModelHelper(
    refreshFn,
    async (orgId: string) => {
      let org: any = null;

      if (getById) {
        org = getById(orgId);
      }

      if (!org) {
        org = await organizationApis.getOrganizationById(orgId);
      }

      return {
        value: org.id || '',
        label: org.name,
      };
    },
    async (needle: string) => {
      let orgs: any = null;

      if (getList) {
        orgs = getList(needle);
      }

      if (orgs === null) {
        orgs = await organizationApis.findOrganizations(needle, orgType);
      }

      return orgs.map((org) => {
        return {
          value: org.id,
          label: org.name,
        }
      });
    },
  );
};


// Location search helper interface
export const createLocationHelper = (refreshFn, getById?, getList?) => {
  return new SearchableModelHelper(
    refreshFn,
    async (locId: string) => {
      let loc: any = null;

      if (getById) {
        loc = getById(locId);
      }

      if (!loc) {
        loc = await locationApis.getLocationById(locId);
      }

      return {
        value: loc.id,
        label: loc.name,
      }
    },
    async (needle: string) => {
      let locations: any = null;

      if (getList) {
        locations = getList(needle);
      }

      if (locations === null) {
        locations = await locationApis.findLocations(needle);
      }

      return locations.map((loc) => {
        return {
          value: loc.id,
          label: loc.name,
        }
      });
    },
  );
};

// Status search helper interface
export const createStatusHelper = (refreshFn, getByKey, getList) => {
  return new SearchableModelHelper(
    refreshFn,
    async (statusKey: string) => {
      const status = getByKey(statusKey);

      return {
        value: status.key,
        label: status.name,
      }
    },
    async (needle: string) => {
      const statuses = getList(needle);

      return statuses.map((status) => {
        return {
          value: status.key,
          label: status.name,
        }
      });
    },
  );
};

export const createOrgLocationsHelper = (refreshFn, organizationId, nullOption: any=null) => {
  return new SearchableModelHelper(
    refreshFn,
    async (locationId) => {
      const location = await locationApis.getLocationById(locationId);

      return {
        value: location?.id,
        label: location?.name,
        entity: location,
      }
    },
    async (needle) => {
      const locations = await locationApis.getOrgLocations(organizationId, { q: needle });

      let options = Array.isArray(locations) ? locations.map(location => ({
        value: location?.id,
        label: location?.name,
        entity: location,
      })) : [];

      if (nullOption) {
        options = [nullOption].concat(options);
      }

      return options;
    }
  )
}

